import React, { useState, useEffect } from 'react';
import { dictionaryList } from '.';
import { LanguageContext } from './LanguageContext';
import { useLocation, useNavigate } from 'react-router-dom'; // Updated to useNavigate

// it provides the language context to app
export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate(); // Replaces useHistory

  // Get the language from the URL or default to 'en'
  const urlParams = new URLSearchParams(location.search);
  const defaultLanguage = urlParams.get('lang') || 'en';

  const [userLanguage, setUserLanguage] = useState(defaultLanguage);

  useEffect(() => {
    // Ensure the lang param is preserved on route changes
    const url = new URL(window.location.href);
    if (!url.searchParams.get('lang')) {
      url.searchParams.set('lang', userLanguage);
      navigate(`${location.pathname}?${url.searchParams.toString()}`, { replace: true });
    }
  }, [location, userLanguage, navigate]);

  const provider = {
    userLanguage,
    dictionary: dictionaryList[userLanguage],
    userLanguageChange: selected => {
      console.log(selected);
      setUserLanguage(selected);
      window.localStorage.setItem('rcml-lang', selected);

      // Update the URL with the selected language
      const url = new URL(window.location.href);
      url.searchParams.set('lang', selected);
      window.history.replaceState(null, '', url.toString());
    }
  };

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  );
};